import React, { useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
const server = process.env.REACT_APP_SERVER;
function ItemSucAnaPro(props) {
    const { suc, fechaIni, actualizar, idProducto,fechaFin,callback } = props
    const [loading, setLoading] = useState(true);
    const [infoAnalisis, setInfoAnalisis] = useState([]);

    useEffect(() => {
        if (fechaIni != '' && idProducto != 0 && fechaFin!='') {
            setLoading(true);
            fetch(`${server}/reporte/getAnalisisProyeccion`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    'regional': JSON.parse(localStorage.getItem('__react_session__')).regional,
                    'idSucursal': suc.ID_SUCURSAL,
                    'fechaIni': fechaIni,
                    'idProducto': idProducto,
                    'fechaFin':fechaFin
                })
            })
                .then(res => res.json())
                .then(data => {
                    setLoading(false);
                    if (data.error) {
                        MsgUtils.msgError(data.error);
                    } else {
                        if(suc.ID_SUCURSAL == 3){
                            console.log(data.ok)
                        }
                        
                        var total = { "CANT_REQ": 0, "CANT_SOBRANTE": 0, "CANT_VENTAS": 0,
                            "TRASP_ENTRANTE":0,"TRASP_SALIENTE":0,'TRASP_ENTRANTE_S':0,'TRASP_SALIENTE_S':0,
                            'TRASP_AUTO':0,'TRASP_MAN':0}
                        for (var i = 0; i < data.ok.dato.length; i++) {
                            total.CANT_REQ += data.ok.dato[i].CANT_REQ;
                            total.CANT_SOBRANTE += data.ok.dato[i].CANT_SOBRANTE;
                            total.CANT_VENTAS += data.ok.dato[i].CANT_VENTAS;
                            total.TRASP_ENTRANTE+=data.ok.dato[i].TRASP_ENTRANTE;
                            total.TRASP_SALIENTE+=data.ok.dato[i].TRASP_SALIENTE;

                            //return { 'ok': { "dato": result.rows, 'proy': resullt.rows,'saliente':resulsaliente.rows,
                                //'entrantes':resulentrante.rows,'salauto':resultraspaso.rows,'salman':resultraspa.rows,
                                 //'otra_consulta': result1.rows, 'jugos_ventas': result2.rows,} }
                        }
                        if(data.ok.proy.length!=0){
                            total.CANT_REQ = data.ok.proy[0].CANTIDAD
                        }
                        if(data.ok.entrantes.length!=0){
                            total.TRASP_ENTRANTE_S =data.ok.entrantes[0].CANTIDAD_DESTINO; 
                        }
                        if(data.ok.saliente.length!=0){
                            total.TRASP_SALIENTE_S =data.ok.saliente[0].CANTIDAD_DESTINO;
                        }
                        if(data.ok.salauto.length!=0){
                            total.TRASP_AUTO = data.ok.salauto[0].CANTIDAD_DESTINO;
                        }
                        if(data.ok.salman.length!=0){
                            total.TRASP_MAN=data.ok.salman[0].CANTIDAD_DESTINO;
                        }

                        if(idProducto == 8 || idProducto == 9 || idProducto == 10){
                            if(suc.ID_SUCURSAL == 11 || suc.ID_SUCURSAL == 39 ){

                                total.CANT_VENTAS += data.ok.jugos_vasitos.reduce((acumulador, item) => acumulador + item.CANT_TOTAL,0);
                                //console.log("CANTIDAD")
                                //console.log(data.ok.jugos_vasitos.reduce((acumulador, item) => acumulador + item.CANT_TOTAL,0))
                                total.CANT_VENTAS = total.CANT_VENTAS.toFixed(2)

                                //console.log("Otra consulta")
                                //console.log(data.ok.otra_consulta.filter((dt)=>[suc.ID_SUCURSAL].indexOf(parseInt(dt.ID_SUCURSAL))!=-1))
    
    
                            }else{
                                //console.log("JUGOS_VENTAS")
                                total.CANT_VENTAS += data.ok.jugos.reduce((acumulador, item) => acumulador + item.CANT_TOTAL,0);
                                //console.log("CANTIDAD")
                                //console.log(data.ok.jugos_vasitos.reduce((acumulador, item) => acumulador + item.CANT_TOTAL,0))
                                total.CANT_VENTAS = total.CANT_VENTAS.toFixed(2)

                            }
                        }

                        /*
                        if(idProducto == 4 ){
                            if(suc.ID_SUCURSAL == 11 || suc.ID_SUCURSAL == 39 ){
                                total.CANT_VENTAS += data.ok.otra_consulta.filter((dt)=>[suc.ID_SUCURSAL].indexOf(parseInt(dt.ID_SUCURSAL))!=-1).reduce(
                                    (acumulador, item) => acumulador + item.CANT_TOTAL,0)
                                total.CANT_VENTAS = total.CANT_VENTAS.toFixed(2)

                            }else{

                                total.CANT_VENTAS += data.ok.jugos_ventas.filter((dt)=>[suc.ID_SUCURSAL].indexOf(parseInt(dt.ID_SUCURSAL))!=-1).reduce(
                                    (acumulador, item) => acumulador + item.CANT_TOTAL,0)
                                total.CANT_VENTAS = total.CANT_VENTAS.toFixed(2)
                            }
                        } */
                        
                        if(suc.ID_SUCURSAL == 3){
                            console.log("INFO TOTAL")
                            console.log(total)
                        }
                        setInfoAnalisis(total);
                    }
                    
                    callback();
                })
                .catch(error => MsgUtils.msgError(error));
        } else {
            setLoading(false);
        }
    }, [actualizar])
    function calcularValor (val1,val2){
        if(idProducto==1){
            return ((val1-(val2)/100)).toFixed(2)
        }else{
            return val1-val2
        }
    }
    return (
        <tr className='text-center'>
            <th scope="row">{suc.SUCURSAL}</th>
            {loading == true && <td><i className="fa-solid fa-spinner fa-spin-pulse"></i></td>}
            {loading == true && <td><i className="fa-solid fa-spinner fa-spin-pulse"></i></td>}
            {loading == true && <td><i className="fa-solid fa-spinner fa-spin-pulse"></i></td>}
            {loading == true && <td><i className="fa-solid fa-spinner fa-spin-pulse"></i></td>}
            {loading == true && <td><i className="fa-solid fa-spinner fa-spin-pulse"></i></td>}
            {loading == true && <td><i className="fa-solid fa-spinner fa-spin-pulse"></i></td>}
            {loading == true && <td><i className="fa-solid fa-spinner fa-spin-pulse"></i></td>}
            {loading == true && <td><i className="fa-solid fa-spinner fa-spin-pulse"></i></td>}
            {loading == true &&false&& <td><i className="fa-solid fa-spinner fa-spin-pulse"></i></td>}
            {loading == true &&false&& <td><i className="fa-solid fa-spinner fa-spin-pulse"></i></td>}
            {loading == false && infoAnalisis.length == 0 && <td><i className="fa-solid fa-question "></i></td>}
            {loading == false && infoAnalisis.length == 0 && <td><i className="fa-solid fa-question "></i></td>}
            {loading == false && infoAnalisis.length == 0 && <td><i className="fa-solid fa-question "></i></td>}
            {loading == false && infoAnalisis.length == 0 && <td><i className="fa-solid fa-question "></i></td>}
            {loading == false && infoAnalisis.length == 0 && <td><i className="fa-solid fa-question "></i></td>}
            {loading == false && infoAnalisis.length == 0 && <td><i className="fa-solid fa-question "></i></td>}
            {loading == false && infoAnalisis.length == 0 && <td><i className="fa-solid fa-question "></i></td>}
            {loading == false && infoAnalisis.length == 0 && <td><i className="fa-solid fa-question "></i></td>}
            {loading == false && infoAnalisis.length == 0 && false&&<td><i className="fa-solid fa-question "></i></td>}
            {loading == false && infoAnalisis.length == 0 && false&&<td><i className="fa-solid fa-question "></i></td>}
            {loading == false && infoAnalisis.length != 0 && <td>{idProducto == 1 ? (infoAnalisis.CANT_VENTAS / 100).toFixed(2) : infoAnalisis.CANT_VENTAS}</td>}
            {loading == false && infoAnalisis.length != 0 && <td>{idProducto == 1 ? (infoAnalisis.CANT_REQ) : infoAnalisis.CANT_REQ}</td>}

            {loading == false && infoAnalisis.length != 0 && 
            <td className={`${calcularValor(infoAnalisis.CANT_REQ,infoAnalisis.CANT_VENTAS)<0.0?'bg-danger':''}`}>
                {idProducto == 1
                    ? ((infoAnalisis.CANT_REQ - (infoAnalisis.CANT_VENTAS) / 100).toFixed(2))
                    : idProducto == 4 || idProducto == 8|| idProducto == 9 ||  idProducto == 10
                        ? (infoAnalisis.CANT_REQ - infoAnalisis.CANT_VENTAS).toFixed(2)
                        : infoAnalisis.CANT_REQ - infoAnalisis.CANT_VENTAS
                }</td>}

            {false&&loading == false && infoAnalisis.length != 0 && <td>{idProducto == 1 ? (infoAnalisis.TRASP_ENTRANTE / 100).toFixed(2) : infoAnalisis.TRASP_ENTRANTE}</td>}
            {loading == false && infoAnalisis.length != 0 && <td>{idProducto == 1 ? (infoAnalisis.TRASP_AUTO / 100).toFixed(2) : infoAnalisis.TRASP_AUTO}</td>}
            {loading == false && infoAnalisis.length != 0 && <td>{idProducto == 1 ? (infoAnalisis.TRASP_MAN / 100).toFixed(2) : infoAnalisis.TRASP_MAN}</td>}
            {loading == false && infoAnalisis.length != 0 && <td>{idProducto == 1 ? (infoAnalisis.TRASP_ENTRANTE_S / 100).toFixed(2) : infoAnalisis.TRASP_ENTRANTE_S}</td>}
            {loading == false && infoAnalisis.length != 0 && <td>{idProducto == 1 ? (infoAnalisis.TRASP_SALIENTE / 100).toFixed(2) : infoAnalisis.TRASP_SALIENTE}</td>}
            {false&&loading == false && infoAnalisis.length != 0 && <td>{idProducto == 1 ? (infoAnalisis.TRASP_SALIENTE_S / 100).toFixed(2) : infoAnalisis.TRASP_SALIENTE_S}</td>}
            {loading == false && infoAnalisis.length != 0 &&
                <td className={` `}>
                    {idProducto == 1 ? (infoAnalisis.CANT_SOBRANTE / 100).toFixed(2) : infoAnalisis.CANT_SOBRANTE}</td>}
        </tr>
    )
}

export default ItemSucAnaPro